import React, { FC } from 'react'
import { PolaroidList } from 'components/SA/Polaroid'
import ListConnector, { ConnectorProps as ListProps } from '../../connectors/List'
import styles from './BrowsePolaroidList.module.scss'
import { useSelector } from 'react-redux'
import { getAlgoliaDataHitsTotal } from 'selectors/algolia2/data'
import { getSelectedCategoryFacetName } from '../../selectors/facets'

type BrowsePolaroidListProps = ListProps & {
  isFiltersVisible?: boolean
  isAlgoliaLoading?: boolean
}

const BrowsePolaroidList: FC<BrowsePolaroidListProps> = ({
  algoliaIndice,
  algoliaUserToken,
  artworks,
  isScreenReady,
  isSet,
  userID,
  isFiltersVisible,
  title,
  searchQuery,
  hasPrints,
  isAlgoliaLoading,
}) => {
  const totalNumberOfResults = useSelector(getAlgoliaDataHitsTotal)
  const selectedCategory = useSelector(getSelectedCategoryFacetName)

  const dataLayerListName = searchQuery ? `Results for "${searchQuery}"` : title

  const handleCheckIsPrintForDataLayerEvent = ({ hasOpenEditions }) => hasOpenEditions && hasPrints

  if (!artworks.length && !isAlgoliaLoading) {
    return (
      <div className={styles.noResults}>
        <h4 className='defaultTypographyH4 defaultTextCapitalize'>
          Sorry, no results were found for that query.
        </h4>
      </div>
    )
  }

  return (
    <PolaroidList
      algoliaIndice={algoliaIndice}
      algoliaUserToken={algoliaUserToken}
      dataApi='algolia'
      dataList='plp-results'
      dataListId='plp-results'
      dataListName={dataLayerListName}
      artworks={artworks}
      isLoading={!isScreenReady || !isSet || isAlgoliaLoading}
      userID={userID}
      customStyle={!isFiltersVisible ? styles.customPolaroidListContainer : ''}
      showPrintsFromInPrice={hasPrints}
      isPrintsFromVisible={false}
      isMediumMaterialVisible={!hasPrints}
      isDimensionsVisible={!hasPrints}
      showOriginalPrice={hasPrints}
      hasPrints={hasPrints}
      onCheckIsPrintForDataLayerEvent={handleCheckIsPrintForDataLayerEvent}
      skeletonQuantity={100}
      searchProviderAttributes={[
        { 'search-results-container': Boolean(searchQuery) },
        { 'browse-container': !Boolean(searchQuery) },
        { 'total-number-results': totalNumberOfResults },
        { 'filter-name': 'group_id' },
        { 'filter-value': selectedCategory },
      ]}
    />
  )
}

export default ListConnector(BrowsePolaroidList)
